import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import GradeMapDetails from "./routes/GradeMapDetails";

export default store => ({
  path: "grade-map",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "grade-map" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
  childRoutes: [GradeMapDetails(store)],
});
